import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  const backendUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

  React.useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      window.location.href = `${backendUrl}/api/scalekit/login`;
    }
  }, [isAuthenticated, isLoading, backendUrl]);

  // Show enhanced loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-slate-900 dark:via-blue-900 dark:to-indigo-900">
        <div className="text-center space-y-4">
          {/* Animated tab icon */}
          <div className="flex justify-center">
            <div className="text-6xl animate-pulse">🔐</div>
          </div>

          {/* Spinner */}
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>

          {/* Message */}
          <p className="text-gray-600 dark:text-gray-300 font-medium">
            Verifying access...
          </p>
        </div>
      </div>
    );
  }

  // If not authenticated, we return null while the useEffect handles the redirect
  if (!isAuthenticated) {
    return null;
  }

  // Render the protected component
  return children;
};

export default ProtectedRoute;
